import cn from 'classnames';
import React, {
    forwardRef, useEffect, useImperativeHandle, useRef,
} from 'react';

import {TDDFilterExpression} from 'features/predicate-expression-form-list';
import {TStateSetter} from 'shared/types/generics';

import {IDDFilterExpressionGroupRef, DDFilterExpressionGroup} from './dd-filter-expression-group';

import './dd-filter-expression-creator.less';

export interface IDDFilterExpressionCreatorProps {
    className?: cn.Argument;
    isInEditMode: boolean;
    setIsInEditMode?: TStateSetter<boolean>;
    initialExpression?: TDDFilterExpression;
}

export interface IDDFilterExpressionCreatorRef {
    getValuesToSave: () => Promise<TDDFilterExpression> | undefined;
    setExpression: ((exp: TDDFilterExpression) => void) | undefined;
}

export const DDFilterExpressionCreator = forwardRef<
IDDFilterExpressionCreatorRef, IDDFilterExpressionCreatorProps>((
    {
        className, isInEditMode, initialExpression,
    }: IDDFilterExpressionCreatorProps,
    ref,
) => {
    const expressionRef = useRef<IDDFilterExpressionGroupRef>(null);

    const getValuesToSave = () => expressionRef.current?.getValues() as Promise<TDDFilterExpression>;
    const setExpression = expressionRef.current?.setExpression;

    useImperativeHandle(ref, () => ({
        getValuesToSave,
        setExpression,
    }));

    useEffect(() => {
        if (initialExpression) setExpression?.(initialExpression);
    }, [initialExpression]);

    return (
        <div className={cn('dd-filter-expression-creator')}>
            <DDFilterExpressionGroup
                ref={expressionRef}
                initialExpression={initialExpression ?? [{connectBy: 'OR'}]}
                className={className}
                isInEditMode={isInEditMode}
                depth={0}
                itemIndex="1"
            />
        </div>
    );
});
